import React, { useState, useEffect } from "react";
import {
  AccordianNew,
  Button,
  FormFieldSet,
  LoopFieldsSet,
  Backdrop,
  LogoLoader,
  PageTitle,
  useFormHandler,
  NewTab,
} from "../../../../components";
import {
  MonsterRadiusOptions,
  optionValuescitizen,
  ClearanceLeveloptions,
  MonsterPowerSearchTravelRequirementsOptions,
  MonsterPowerSearchTenureOptions,
  MonsterEducationLevel,
  careerMonsterLevelOptions,
  MonsterSearchResumeUpdatedOptions,
} from "../../../../assets/data/enumData";
import RecentHistory from "../CommonJobBoardTabs/RecentHistory";
import SavedHistory from "../CommonJobBoardTabs/SavedHistory";
import { v4 as uuidv4 } from "uuid";
import { useDispatch, useSelector } from "react-redux";
import { getMonsterApplicantsDataStart } from "../../../../redux/slices/internalDbES/internalDbESlice";
import SearchResults from "../SearchResults";
import { showToast } from "../../../../components";
import {
  getCountries,
  getLocations,
} from "../../../../redux/slices/internalDbES/internalDbESApi";
import { normalizeQuotes } from "../../../../utils/common";

const MonsterSearch = ({ loadMonster, saveAccessId, setShowButtons }) => {
  const dispatch = useDispatch();
  const [searchApplicant, setSearchApplicant] = useState(false);

  useEffect(() => {
    if (!searchApplicant) {
      setShowButtons(true);
    }
  }, [searchApplicant, setShowButtons]);
  const { user } = useSelector((state) => state.auth);
  const [advancedSearch, setAdvancedSearch] = useState(false);
  const { loading } = useSelector((state) => state.internalDbES);
  const [requestBody, setRequestBody] = useState(null);
  const [selectedCountryId, setSelectedCountryId] = useState({});
  const [selectedTitle, setSelectedTitle] = useState("");
  const [selectedCountry, setSelectedCountry] = useState(null);
  const [selectedCountryCode, setSelectedCountryCode] = useState(null);
  const [locationTypingValue, setLocationTypingValue] = useState("");
  const [locations, setLocations] = useState([]);
  const decodeMonsterSearchSkills = (skills) => {
    if (!Array.isArray(skills) || skills.length === 0) return [];

    return skills
      .map((skill) => {
        if (typeof skill !== "string") return null;

        const encodedValue = skill.split(" ")[0];

        try {
          return decodeURIComponent(decodeURIComponent(encodedValue));
        } catch {
          return encodedValue;
        }
      })
      .filter(Boolean);
  };

  const safeDecode = (v) => {
    try {
      return typeof v === "string" ? decodeURIComponent(v) : v;
    } catch {
      return v;
    }
  };

  const handleSelect = ({ title, filterTerms = {} }) => {
    setLocationTypingValue(safeDecode(filterTerms?.loc)?.replace(/-\d+$/, ""));
    
    const mapped = {
      searchType: filterTerms?.searchType ?? "Boolean Search",
      jobTitle: "",
      country: filterTerms?.country ?? "United States",
      distance: filterTerms?.radius ?? "",
      //  skills: Array.isArray(filterTerms?.sk)
      // ? filterTerms.sk.flat(Infinity).filter(Boolean)
      // : [],
      location: safeDecode(filterTerms?.loc),
      skills: Array.isArray(filterTerms?.sk)
        ? decodeMonsterSearchSkills(filterTerms.sk.flat(Infinity)).join(", ")
        : "",
      booleanKeywords: safeDecode(filterTerms?.bkeyword) ?? "",
      company: String(filterTerms?.comp || "")
        .split(",")
        .map((s) => s.trim())
        .filter(Boolean)
        .map((v) => ({ id: uuidv4(), companyName: v })),

      degree: String(filterTerms?.edumjr || "")
        .split(",")
        .map((s) => s.trim())
        .filter(Boolean)
        .map((v) => ({ id: uuidv4(), degreeName: v })),

      school: String(filterTerms?.sch || "")
        .split(",")
        .map((s) => s.trim())
        .filter(Boolean)
        .map((v) => ({ id: uuidv4(), schoolName: v })),

      candidateFilters: (() => {
        const filters = [];
        if (filterTerms?.relo === true || filterTerms?.relo === "true") {
          filters.push("Willing to Relocate");
        }
        if (filterTerms?.veteran === 1 || filterTerms?.veteran === "1") {
          filters.push("Veterans Only");
        }
        return filters;
      })(),
      workAuthorization: (filterTerms?.wa && String(filterTerms?.wa)) ?? "",
      yearsOfExperience: (filterTerms?.yex && String(filterTerms?.yex)) ?? "",
      careerLevel: filterTerms?.clvid
        ? String(filterTerms.clvid)
            .split(",")
            .map(Number)
            .filter((n) => !isNaN(n))
        : [],
      jobDuration: (filterTerms?.ten && String(filterTerms?.ten)) ?? "",
      //resumeUploaded: (filterTerms?.mdatemaxage && filterTerms?.mdatemaxage) ?? 1576800,
      candidateName: (filterTerms?.cname && String(filterTerms?.cname)) ?? "",
      jobType: filterTerms?.tjtid
        ? String(filterTerms.tjtid)
            .split(",")
            .map(Number)
            .filter((n) => !isNaN(n))
        : [],
      citizenship: [],
      securityClearance: filterTerms?.gsc
        ? String(filterTerms.gsc)
            .split(",")
            .map(Number)
            .filter((n) => !isNaN(n))
        : [],
      salaryType: "",
      salaryLevel: "",
      travel: (filterTerms?.wtt && String(filterTerms?.wtt)) ?? "",
      education:
        (filterTerms?.minedulvid && String(filterTerms?.minedulvid)) ?? "",
    };

    setFormData({
      ...initialFormData,
      ...mapped,
    });
    setSelectedTitle(title);
  };

  const initialFormData = {
    searchType: "Boolean Search",
    jobTitle: "",
    skills: "",
    booleanKeywords: "",
    location: "",
    country: "United States",
    distance: 50,
    company: [{ id: uuidv4(), companyName: "" }],
    degree: [{ id: uuidv4(), degreeName: "" }],
    school: [{ id: uuidv4(), schoolName: "" }],
    candidateFilters: [],
    workAuthorization: "",
    yearsOfExperience: "",
    careerLevel: [],
    jobDuration: "",
    includeDetails: "1",
    resumeUploaded: 0,
    candidateName: "",
    jobType: [],
    citizenship: [],
    securityClearance: [],
    salaryType: "year",
    salaryLevel: "",
    travel: "",
    education: "",
  };

  const { formData, errors, handleChange, setFormData } = useFormHandler(
    initialFormData,
    {}
  );

  const addCompany = () =>
    setFormData({
      ...formData,
      company: [...formData.company, { id: uuidv4(), companyName: "" }],
    });

  const removeCompany = (id) =>
    formData.company.length > 1 &&
    setFormData({
      ...formData,
      company: formData.company.filter((c) => c.id !== id),
    });

  const addDegree = () =>
    setFormData({
      ...formData,
      degree: [...formData.degree, { id: uuidv4(), degreeName: "" }],
    });

  const removeDegree = (id) =>
    formData.degree.length > 1 &&
    setFormData({
      ...formData,
      degree: formData.degree.filter((d) => d.id !== id),
    });

  const addSchool = () =>
    setFormData({
      ...formData,
      school: [...formData.school, { id: uuidv4(), schoolName: "" }],
    });

  const removeSchool = (id) =>
    formData.school.length > 1 &&
    setFormData({
      ...formData,
      school: formData.school.filter((s) => s.id !== id),
    });

  const handleMonsterSearch = ({ title, filterTerms }) => {
    handleSearch(title, filterTerms);
    setSelectedTitle("");
  };

  //   const formatMonsterSearchSkills = (skills) => {
  //   if (!Array.isArray(skills) || skills.length === 0) return "";

  //   return skills
  //     .filter(skill => typeof skill === "string" && skill.trim())
  //     .map(skill =>
  //       `${encodeURIComponent(encodeURIComponent(skill.trim()))} nth`
  //     );
  // };

  const formatMonsterSkills = (skills) => {
    if (!Array.isArray(skills) || skills.length === 0) return "";

    const doubleEncode = (str) =>
      encodeURIComponent(encodeURIComponent(str.trim()));

    const processed = skills
      .map((skill) => {
        // Case 1: skill is a string
        if (typeof skill === "string" && skill.trim()) {
          return `${doubleEncode(skill)} nth`;
        }

        // Case 2: skill is an object { value, req }
        if (skill?.value && skill.value.trim()) {
          return `${doubleEncode(skill.value)} ${skill?.req || "nth"}`;
        }

        return null;
      })
      .filter(Boolean);

    return processed.length > 0 ? processed : "";
  };

  const handleSearch = async (title, filterTerms) => {
    if (
      formData.searchType === "Semantic" &&
      !formData.jobTitle.trim() &&
      !title &&
      !selectedTitle
    ) {
      showToast("Please enter a Job Title.", "error");
      return;
    }

    if (
      formData.searchType === "Boolean Search" &&
      !formData.booleanKeywords.trim() &&
      !title &&
      !selectedTitle
    ) {
      showToast("Please enter Boolean search keywords.", "error");
      return;
    }

    const keyword =
      formData?.jobTitle || formData.booleanKeywords || title || selectedTitle;
    const openParen = (keyword.match(/\(/g) || []).length;
    const closeParen = (keyword.match(/\)/g) || []).length;

    if (openParen !== closeParen) {
      showToast("Invalid keyword syntax: missing ')'.", "error", 2000);
      return;
    }

    // check unbalanced double quotes
    const quotes = (keyword.match(/"/g) || []).length;

    if (quotes % 2 !== 0) {
      showToast('Invalid keyword syntax: missing closing "', "error", 2000);
      return;
    }

    let booleanSearchTitle;
    let powerSearchTitle;
    if (formData.searchType == "Boolean Search") {
      booleanSearchTitle = selectedTitle || title;
      powerSearchTitle = "";
    } else {
      booleanSearchTitle = "";
      powerSearchTitle = selectedTitle || title;
    }
    const [state, city, zipCode] = locationTypingValue.split(",");

    const distance = formData.distance || 50;

    const locationParts = [state, city, zipCode].filter(Boolean);

    const locationValue = locationParts.length
      ? `${locationParts.join(",")}-${distance}`
      : "";

    const newRequestBody = {
      accessId: saveAccessId,
      searchType: "monster",
      payload: {
        query: {
          searchType: formData.searchType,
          // jt: formData.jobTitle || powerSearchTitle,
          // bkeyword: formData.booleanKeywords || booleanSearchTitle,
          jt: formData.jobTitle
            ? encodeURIComponent(formData?.jobTitle)
            : encodeURIComponent(powerSearchTitle),

          bkeyword: formData.booleanKeywords
            ? encodeURIComponent(formData?.booleanKeywords)
            : encodeURIComponent(booleanSearchTitle),
          // sk: formData.skills,
          sk: formData?.skills ? formatMonsterSkills([formData?.skills]) : "",
          radius: formData.distance || 50,
          mdatemaxage:
            formData.resumeUploaded === 0
              ? 1576800
              : 1440 * formData.resumeUploaded,
          // location:
          //   state && city && zipCode
          //     ? `${state},${city}-${zipCode}`
          //     : "",
          // location:
          //   state && city && zipCode
          //     ? `${state},${city},${zipCode}-${formData.distance || 50}`
          //     : "",
          // location: locationParts.length
          //   ? `${locationParts.join(",")}-${distance}`
          //   : "",
          loc: encodeURIComponent(locationValue) || "US",
          country: Number(selectedCountryCode) || "US",
          comp: formData?.company
            ?.map((c) => c.companyName?.trim())
            .filter(Boolean)
            .join(","),
          edumjr: formData?.degree
            ?.map((c) => c.degreeName?.trim())
            .filter(Boolean)
            .join(","),
          sch: formData?.school
            ?.map((c) => c.schoolName?.trim())
            .filter(Boolean)
            .join(","),

          tjtid: formData.jobType?.filter(Boolean).join(", ") || "",
          lstat: formData.citizenship?.filter(Boolean).join(", ") || "",
          gsc: formData.securityClearance?.filter(Boolean).join(", ") || "",
          wa: formData?.workAuthorization ? formData.workAuthorization : "",
          yex: formData.yearsOfExperience,
          wtt: formData.travel,
          ten: formData.jobDuration,
          minedulvid: formData.education,
          clvid: formData.careerLevel?.filter(Boolean).join(",") || "",
          relo: formData.candidateFilters?.includes("Willing to Relocate")
            ? true
            : "",
          veteran: formData.candidateFilters?.includes("Veterans Only")
            ? 1
            : "",
          // mdatemaxage:
          //   formData.resumeUploaded === 0
          //     ? 1576800
          //     : 1440 * formData.resumeUploaded,
          // tsni:1,
          tsni: Number(formData.includeDetails) || "",

          cname: formData.candidateName,
          salaryType: formData.salaryType,
          salaryLevel: formData.salaryLevel,
          ...filterTerms,
        },
        page: 1,
        lim: 25,
        source: 5,
        addedBy: user?.data?.uiid,
      },
    };

    try {
      setRequestBody(newRequestBody);
      dispatch(
        getMonsterApplicantsDataStart({
          ...newRequestBody,
          onSuccess: () => {
            setSearchApplicant((prev) => !prev);
            setFormData(initialFormData);
            setLocationTypingValue("");
            setSelectedTitle("")
          },
        })
      );
    } catch (error) {
      console.error("Monster search error:", error);
    }
  };
  const monsterMenus = [
    {
      title: "Recent History",
      page: (
        <RecentHistory
          board="monster"
          subBoard="monster"
          onSelect={handleSelect}
          onClick={handleMonsterSearch}
        />
      ),
      type: "main",
    },
    {
      title: "Saved History",
      page: (
        <SavedHistory
          board="monster"
          subBoard="monster"
          onSelect={handleSelect}
          onClick={handleMonsterSearch}
        />
      ),
      type: "main",
    },
  ];
  const data = [
    {
      title: "Resume Search Criteria",
      content: (
        <div>
          {/* Years of Experience */}
          <FormFieldSet
            title="Years of Experience"
            placeholder="Suggested,4,2-3,5+,<8"
            value={formData.yearsOfExperience || ""}
            onChange={(value) => handleChange("yearsOfExperience", value)}
            shadow
          />
          <p className="text-xs text-neutrals-400 my-1">
            (e.g, MBA, MS Math, MSCS, English)
          </p>

          {/* Career Level */}
          <div className="my-3">
            <FormFieldSet
              type="checkbox"
              title="Career Level"
              options={careerMonsterLevelOptions}
              values={formData.careerLevel || []}
              onChange={(value) => handleChange("careerLevel", value)}
              multiple
            />
          </div>

          {/* Job Duration */}
          {/* Job Duration */}
          <div className="my-3">
            <FormFieldSet
              type="radio"
              name="jobDuration"
              title="Job Duration"
              options={MonsterPowerSearchTenureOptions}
              value={formData.jobDuration || ""}
              onChange={(e) => handleChange("jobDuration", e.target.value)}
            />
          </div>

          {/* Companies */}
          <LoopFieldsSet
            title="Companies"
            titleConfig={{tag:'h6',}}
            data={formData.company}
            onAdd={addCompany}
            onRemove={removeCompany}
            maxItems={3}
            gridCols="grid-cols-10"
            addButtonTitle="Add Companies"
            renderFields={(company, index) => (
              <div className="col-span-9">
                <FormFieldSet
                  type="text"
                  noTitle
                  placeholder="(e.g. IHOP Corp, IBM Global Services)"
                  value={company?.companyName || ""}
                  onChange={(value) => {
                    const updated = [...formData?.company];
                    updated[index].companyName = value;
                    setFormData({ ...formData, company: updated });
                  }}
                  shadow
                />
              </div>
            )}
          />

          {/* Degrees */}
          <LoopFieldsSet
            title="Degrees"
            titleConfig={{tag:"h6",}}
            data={formData.degree}
            onAdd={addDegree}
            onRemove={removeDegree}
            maxItems={3}
            gridCols="grid-cols-10"
            addButtonTitle="Add Degrees"
            renderFields={(deg, index) => (
              <div className="col-span-9">
                <FormFieldSet
                  type="text"
                  noTitle
                  placeholder="(e.g. Computer Engineering)"
                  value={deg.degreeName || ""}
                  onChange={(value) => {
                    const updated = [...formData.degree];
                    updated[index].degreeName = value;
                    setFormData({ ...formData, degree: updated });
                  }}
                  shadow
                />
                <FormFieldSet
                  type="checkbox"
                  options={[{ label: "Required", value: "Required" }]}
                  values={deg.required || []}
                  onChange={(value) => {
                    const updated = [...formData.degree];
                    updated[index].required = value;
                    setFormData({ ...formData, degree: updated });
                  }}
                  noTitle
                  multiple
                />
              </div>
            )}
          />

          {/* Schools */}
          <LoopFieldsSet
            title="Schools"
            titleConfig={{tag:"h6",}} 
            data={formData.school}
            onAdd={addSchool}
            onRemove={removeSchool}
            maxItems={3}
            gridCols="grid-cols-10"
            addButtonTitle="Add Schools"
            renderFields={(sch, index) => (
              <div className="col-span-9">
                <FormFieldSet
                  type="text"
                  noTitle
                  placeholder="(e.g. UCLA, Siena College, Lowa State Univ)"
                  value={sch.schoolName || ""}
                  onChange={(value) => {
                    const updated = [...formData.school];
                    updated[index].schoolName = value;
                    setFormData({ ...formData, school: updated });
                  }}
                  shadow
                />
              </div>
            )}
          />
        </div>
      ),
    },
    {
      title: "Profile Search Criteria",
      content: (
        <div className="space-y-3">
          <p className="text-sm my-3">
            Please be advised that these search options come from candidate
            profiles, so results may vary depending on what information is
            provided.
          </p>

          {/* Resume Uploaded + Candidate Name */}
          <div className="grid grid-cols-2 md:grid-cols-1 gap-3 my-3">
            <FormFieldSet
              type="select"
              title="Resume Uploaded"
              placeholder="All Resumes"
              options={MonsterSearchResumeUpdatedOptions}
              value={formData?.resumeUploaded}
              onChange={(value) => handleChange("resumeUploaded", value)}
              shadow={true}
            />
            <FormFieldSet
              title="Candidate Name"
              placeholder="(e.g. mark, john wayne)"
              value={formData.candidateName || ""}
              onChange={(value) => handleChange("candidateName", value)}
            />
          </div>

          {/* Job Type */}
          <FormFieldSet
            type="checkbox"
            size="md"
            title="Job Type"
            options={[
              { label: "Full-Time", value: 1 },
              { label: "Part-time", value: 2 },
              { label: "Intern", value: 3 },
              { label: "Temporary/Contract", value: 4 },
              { label: "Seasonal", value: 5 },
            ]}
            values={formData.jobType || []}
            onChange={(value) => handleChange("jobType", value)}
            multiple
          />

          {/* Citizenship */}
          <FormFieldSet
            type="checkbox"
            title="Citizenship"
            options={optionValuescitizen}
            values={formData.citizenship || []}
            onChange={(value) => handleChange("citizenship", value)}
            multiple
          />

          {/* Security Clearance */}
          <FormFieldSet
            type="checkbox"
            title="Security Clearance"
            options={ClearanceLeveloptions}
            values={formData.securityClearance || []}
            onChange={(value) => handleChange("securityClearance", value)}
            multiple
          />
          <div className="mt-3 mb-2">
            {/* Maximum Salary */}
            <FormFieldSet
              type="radio"
              title="Maximum Salary"
              name="maxSalary"
              list
              options={[
                { label: "Per Year", value: "year" },
                { label: "Per Hour", value: "hour" },
              ]}
              value={formData.salaryType || ""}
              onChange={(e) => handleChange("salaryType", e.target.value)}
            />
          </div>
          <FormFieldSet
            type="select"
            noTitle
            placeholder="Salary Level"
            options={[
              { label: "$30,000", value: "30000" },
              { label: "$40,000", value: "40000" },
              { label: "$50,000", value: "50000" },
              { label: "$60,000", value: "60000" },
              { label: "$70,000", value: "70000" },
              { label: "$80,000", value: "80000" },
              { label: "$90,000", value: "90000" },
            ]}
            value={formData.salaryLevel || ""}
            onChange={(value) => handleChange("salaryLevel", value)}
          />

          <FormFieldSet
            type="checkbox"
            size="md"
            noTitle
            placeholder="Select"
            options={[
              {
                label: "Include candidates without salary information",
                value: "1",
              },
            ]}
            values={formData?.includeDetails}
            onChange={(value) => handleChange("includeDetails", value)}
            error={errors?.includeDetails}
          />

          {/* Travel */}
          <FormFieldSet
            type="radio"
            title="Willing To Travel"
            name="willingToTravel"
            options={MonsterPowerSearchTravelRequirementsOptions}
            value={formData.travel || ""}
            onChange={(e) => handleChange("travel", e.target.value)}
          />

          {/* Education */}
          <FormFieldSet
            type="radio"
            title="Education"
            name="education"
            options={MonsterEducationLevel}
            value={formData.education || ""}
            onChange={(e) => handleChange("education", e.target.value)}
          />
        </div>
      ),
    },
  ];

  // useEffect(() => {
  //       if (!locationTypingValue) return;
  //       const [city, state, zip] = locationTypingValue.split(",");
  //       if (city && state) return;

  //       const delay = setTimeout(async () => {
  //         setLocations([])
  //         const response = await getLocations({ locationValue: locationTypingValue, country: selectedCountry?._id });
  //         if (response?.success) {
  //           const locationData = response?.data?.data
  //             .map((item) => {
  //               const name = item.name ?? "";
  //               const state = item.stateName ?? "";
  //               const zip = item.zipCode ?? "";

  //               return `${name},${state},${zip}`.trim();
  //             });
  //           setLocations(locationData)
  //         }
  //       }, 0);

  //       return () => clearTimeout(delay);
  //     }, [locationTypingValue, formData?.country]);

  //     useEffect(() => {
  //       if (!formData?.country) return;

  //       const delay = setTimeout(async () => {
  //         const response = await getCountries({ name: formData?.country });
  //         // console.log("response",response)
  //         const countries = response.data.data
  //         const desiredCountry = countries[0];

  //         setSelectedCountry(desiredCountry);
  //         setSelectedCountryCode(desiredCountry?.numericCode)
  //         setLocationTypingValue("")
  //       }, 0);

  //       return () => clearTimeout(delay);
  //     }, [formData?.country]);

  useEffect(() => {
    if (!locationTypingValue) return;
    const [city, state, zip] = (locationTypingValue ?? "").split(",");
    if (city && state) return;

    const delay = setTimeout(async () => {
      setLocations([]);
      const response = await getLocations({
        locationValue: locationTypingValue,
        country: selectedCountryId?._id,
        limit: 500,
      });
      if (response?.success) {
        // const uniqueStates = [...new Set((response?.data?.data || []).map(item => item.stateName))];
        const locationData = response?.data?.data.flatMap((item) => {
          const name = item.name ?? "";
          const state = item.stateName ?? "";
          if (Array.isArray(item.zipCode)) {
            return item.zipCode.map((zc) => `${name},${state},${zc}`);
          }
          return [`${name},${state},${item.zipCode ?? ""}`];
        });
        //  setLocations([...uniqueStates,...locationData ])
        const search = locationTypingValue.toLowerCase();
        // const statesStartsWith = uniqueStates.filter((item) =>
        //   item.toLowerCase().startsWith(search)
        // );
        // const statesContains = uniqueStates.filter(
        //   (item) =>
        //     item.toLowerCase().includes(search) &&
        //     !item.toLowerCase().startsWith(search)
        // );
        const locationsStartsWith = locationData.filter((item) =>
          item.toLowerCase().startsWith(search)
        );
        const locationsContains = locationData.filter(
          (item) =>
            item.toLowerCase().includes(search) &&
            !item.toLowerCase().startsWith(search)
        );
        // statesStartsWith.sort((a, b) => a.localeCompare(b));
        // statesContains.sort((a, b) => a.localeCompare(b));
        locationsStartsWith.sort((a, b) => a.localeCompare(b));
        locationsContains.sort((a, b) => a.localeCompare(b));
        setLocations([
          // ...statesStartsWith,
          ...locationsStartsWith,
          // ...statesContains,
          ...locationsContains,
        ]);
      }
    }, 0);

    return () => clearTimeout(delay);
  }, [locationTypingValue, formData?.country]);

  useEffect(() => {
    if (!formData?.country) return;

    const delay = setTimeout(async () => {
      const response = await getCountries({ name: formData?.country });
      const countries = response?.data?.data;
      const desiredCountryId = countries[0];
      setSelectedCountryId(desiredCountryId);
      setSelectedCountryCode(desiredCountryId?.numericCode);
      setLocationTypingValue("");
    }, 0);

    return () => clearTimeout(delay);
  }, [formData?.country]);

  return !searchApplicant ? (
    <div>
      <div className="p-3 m-2 flex flex-1 md:flex-col lg:flex-row rounded-md">
        <div className="flex-1 inner-section p-3">
          <p className="font-[500]">Applicant Search In Monster</p>

          {/* Search Type */}
          <FormFieldSet
            noTitle
            type="radio"
            name="searchType"
            options={[
              { label: "Semantic Search", value: "Semantic" },
              { label: "Boolean Search", value: "Boolean Search" },
            ]}
            value={formData.searchType}
            onChange={(e) => handleChange("searchType", e.target.value)}
            error={errors.searchType}
          />

          {/* SEMANTIC Search */}
          {formData.searchType === "Semantic" && (
            <>
              <div>
                <p className="text-sm font-[500] my-2">Job Title</p>
                <FormFieldSet
                  type="text"
                  title="Entering a Job Title is highly recommended"
                  placeholder="Job Title"
                  value={formData.jobTitle || selectedTitle}
                  onChange={(value) => {
                    handleChange("jobTitle", value);
                    setSelectedTitle("");
                  }}
                  shadow={true}
                />
                <p className="mt-1 text-xs">(eg, Sales, Accountant,)</p>
              </div>
              <div>
                <p className="text-sm font-[500] my-2">Skill Keywords</p>
                <FormFieldSet
                  type="text"
                  title="Enter terms related to candidates industry, or expertise (e.g java,telesales,call center,SOX)"
                  placeholder="Skills"
                  value={formData.skills}
                  onChange={(value) => handleChange("skills", value)}
                  shadow={true}
                />
              </div>
            </>
          )}

          {/* BOOLEAN Search */}
          {formData.searchType === "Boolean Search" && (
            <FormFieldSet
              title="Boolean Search"
              placeholder="Javascript, Management, Finance"
              value={formData.booleanKeywords || selectedTitle}
              onChange={(value) =>
                handleChange("booleanKeywords", normalizeQuotes(value))
              }
              shadow
            />
          )}
          <p className="text-sm font-[500] my-2">Location</p>
          <div className="grid grid-cols-2  gap-4">
            <FormFieldSet
              noTitle
              // type="text"
              placeholder="Location"
              // value={formData?.zipCode}
              value={locationTypingValue}
              // onChange={(value) => handleChange("zipCode", value)}
              onChange={(value) => {
                setLocationTypingValue(value);
                handleChange("location", value);
                setLocations([]);
              }}
              // error={errors?.zipCode}
              shadow={true}
              suggestionsList={locations}
            />
            <FormFieldSet
              type="select"
              noTitle
              options={MonsterRadiusOptions}
              placeholder="30 miles away"
              value={formData?.distance}
              onChange={(value) => handleChange("distance", value)}
              error={errors?.distance}
              shadow={true}
            />
          </div>

          {/* Advanced Search Toggle */}
          <div className="flex justify-end my-3">
            <Button
              icon="add"
              variant="text"
              title={
                advancedSearch ? "Hide Advanced Search" : "Advanced Search"
              }
              color="info"
              onClick={() => setAdvancedSearch((prev) => !prev)}
            />
          </div>

          {/* Advanced Search Section */}
          {advancedSearch && (
            <div>
              <PageTitle title="Advanced Search" tag="h5" />
              <br />

              {/* Relocation / Veteran Filters */}
              <PageTitle title="Select Candidate Filters" tag="h6" />
              <FormFieldSet
                type="checkbox"
                noTitle
                multiple
                options={[
                  {
                    label: "Limit results to candidates willing to relocate",
                    value: "Willing to Relocate",
                  },
                  {
                    label: "Limit results to designated as veterans",
                    value: "Veterans Only",
                  },
                ]}
                values={formData.candidateFilters || []}
                onChange={(value) => handleChange("candidateFilters", value)}
              />

              {/* Work Authorization */}
              {/* Work Authorization */}
              <div className="grid grid-cols-1 lg:grid-cols-1 gap-2 mt-4">
                <PageTitle title="Work Authorization" tag="h6" />
                <FormFieldSet
                  noTitle
                  type="radio"
                  name="workAuth"
                  list
                  options={[
                    { label: "Show all job seekers", value: "" },
                    {
                      label:
                        "Limit to job seekers authorized to work in this country for any employer",
                      value: "164-1",
                    },
                    {
                      label:
                        "Limit to job seekers authorized to work in this country for their current employer only",
                      value: "164-2",
                    },
                    {
                      label:
                        "Limit to job seekers that require sponsorship to work in this country",
                      value: "164-3",
                    },
                  ]}
                  value={formData.workAuthorization || ""}
                  onChange={(e) =>
                    handleChange("workAuthorization", e.target.value)
                  }
                />
              </div>

              {/* Accordion for Advanced Filters */}
              <div className="my-3">
                <AccordianNew data={data} color="white" variant="outlined" />
              </div>
            </div>
          )}

          {/* Action Buttons */}
          <div className="flex justify-end gap-4 my-4">
            <Button
              title="Reset"
              size="sm"
              variant="outlined"
              onClick={() => {
                setFormData(initialFormData);
                setSelectedTitle("");
              }}
            />
            <Button
              disabled={!loadMonster && !saveAccessId}
              title="Search"
              size="sm"
              onClick={() => handleSearch()}
            />
          </div>
        </div>

        <div className="flex flex-1 flex-col ">
          <p className="font-[600] my-2">Strings History</p>
          <div className="flex flex-1 shadow my-2 p-3 ">
            <NewTab
              tabs={monsterMenus}
              color="gray"
              variant="text"
              activeVariant="text"
            />
          </div>
        </div>
      </div>

      <Backdrop isOpen={loading}>
        <LogoLoader />
      </Backdrop>
    </div>
  ) : (
    <div className="flex flex-1 flex-col overflow-hidden mt-2">
      <SearchResults
        source={3}
        query={requestBody}
        loading={loading}
        setShowButtons={setShowButtons}
        setSearchApplicant={setSearchApplicant}
      />
    </div>
  );
};

export default MonsterSearch;
